import { reactive } from 'vue';

export default reactive({
  user: [],
  page: 'env',
  clientConfig: null,
  crash: {
    connectionState: 'disconnected'
  },
  apiBaseUrl: null,
  environment: null,
  environments: [],
  users: []
});

